import { render, staticRenderFns } from "./BlackDialog.vue?vue&type=template&id=215bffac&scoped=true&"
import script from "./BlackDialog.vue?vue&type=script&lang=js&"
export * from "./BlackDialog.vue?vue&type=script&lang=js&"
import style0 from "./BlackDialog.vue?vue&type=style&index=0&id=215bffac&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "215bffac",
  null
  
)

export default component.exports